import { jsx as _jsx } from "react/jsx-runtime";
import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import { FormattedMessage } from "react-intl";
import Typography from "@material-ui/core/Typography";
addRegisteredSectionLayout({
    name: "ForbiddenPageSection",
    displayName: "ForbiddenPageSection",
    settings: {}
});
const ForbiddenPageSection = (props) => (_jsx(Typography, { variant: "h4", className: props.className, onClick: props.onClick, children: _jsx(FormattedMessage, { id: "form.section.forbidden-product", description: "Text for forbidden product", defaultMessage: "You do not have access to this product. Contact your case manager if you need info." }) }));
ForbiddenPageSection.displayName = "DployForbiddenPageSection";
export { ForbiddenPageSection };
//# sourceMappingURL=ForbiddenPageSection.js.map